import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  loginUserAction,
  setAuthTokenAction,
  setRefreshTokenAction,
  setUserDataAction,
  setVerificationStatusAction,
} from '@/js/reduxstore/actions/authActions';
import logo from '@/js/images/blackLogo.svg';
import createApiClient from '@/api/axiosInstance';

const GoogleRedirectPage = ({ setError }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiClient = createApiClient(navigate, dispatch);

  // Function to handle Google authentication
  const handleGoogleAuth = async (code) => {
    try {
      const response = await apiClient.post(
        '/oauth/google/signup',
        JSON.stringify({
          authorizationCode: code,
        }),
        {
          authRequired: false,
        },
      );

      const data = response.data;
      console.log('User API Response:', data);

      try {
        const userDetailsResponse = await apiClient.get('/user-details/get', {
          authRequired: false,
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': data.data.x_auth_key,
          },
        });

        const userDetails = userDetailsResponse.data;
        console.log('User Details API Response:', userDetails);

        // Step 3: Map user_type to lowercase role
        const userType = userDetails.data.user_type?.toLowerCase();
        const user_role =
          userType === 'buyer'
            ? 'buyer'
            : userType === 'manufacturer'
              ? 'supplier'
              : null;

        localStorage.setItem('authKeyExpiredAt', data.data.auth_key_expired_at);
        localStorage.setItem(
          'refreshTokenExpiredAt',
          data.data.refresh_token_expiration,
        );
        localStorage.setItem('accessToken', data.data.x_auth_key);
        localStorage.setItem('refreshToken', data.data.refresh_token);

        if (user_role) {
          await Promise.all([
            dispatch(setAuthTokenAction(data.data.x_auth_key)),
            dispatch(setRefreshTokenAction(data.data.refresh_token)),
            dispatch(
              loginUserAction({
                x_auth_key: data.data.x_auth_key,
                user_id: userDetails.data.user_id,
                user_type_id: userDetails.data.user_type_id,
                role: user_role,
                company_name: userDetails.data.company_name,
                name: userDetails.data.name,
                email: userDetails.data.email,
              }),
            ),
            dispatch(
              setUserDataAction({
                isVerified: true,
                role: user_role,
                user_id: userDetails.data.user_id,
                user_type_id: userDetails.data.user_type_id,
                token: data.data.x_auth_key,
                company_name: userDetails.data.company_name,
                name: userDetails.data.name,
                email: userDetails.data.email,
              }),
            ),
            dispatch(setVerificationStatusAction(true)),
          ]);
          navigate(`/${user_role}/dashboard`);
        } else {
          await Promise.all([
            dispatch(setAuthTokenAction(data.data.x_auth_key)),
            dispatch(setRefreshTokenAction(data.data.refresh_token)),
            dispatch(
              setUserDataAction({
                name: userDetails.data.name,
                email: userDetails.data.email,
                isVerified: true,
              }),
            ),
            dispatch(setVerificationStatusAction(true)),
          ]);
          navigate('/roles');
        }
      } catch (error) {
        console.log(error.message);
        alert('An error occurred during authentication');
        navigate('/signup');
      }
    } catch (error) {
      console.log(error.message || 'An error occurred during authentication');
      alert('An error occurred during authentication');
      navigate('/signup');
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get('code');
    const error = queryParams.get('error');

    if (code) {
      handleGoogleAuth(code);
    } else if (error) {
      console.error('Google Authentication Error:', error);
      alert(`Authentication Error: ${error}`);
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <img src={logo} className="w-[67px]" alt="MakerSharks-logo" />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          WELCOME TO MAKERSHARKS
        </h1>
        <p className="text-gray-600 mb-6">
          Authenticating your account, please wait...
        </p>
        <div className="w-full">
          <div className="h-1.5 w-full overflow-hidden">
            <div className="animate-progress w-full h-full bg-darkPurple origin-left-right"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleRedirectPage;
